export const PRIMARY = 'PRIMARY';
export const SECONDARY = 'SECONDARY';

export const CERTIFICATE_URLS = {
    PRIMARY: {
        BRONZE: '//west.cdn.mathletics.com/certificate-images/v1/primary-background-bronze.png',
        SILVER: '//west.cdn.mathletics.com/certificate-images/v1/primary-background-silver.png',
        GOLD: '//west.cdn.mathletics.com/certificate-images/v1/primary-background-gold.png'
    },
    SECONDARY: {
        BRONZE: '//west.cdn.mathletics.com/certificate-images/v1/secondary-background-bronze.png',
        SILVER: '//west.cdn.mathletics.com/certificate-images/v1/secondary-background-silver.png',
        GOLD: '//west.cdn.mathletics.com/certificate-images/v1/secondary-background-gold.png'
    }
};



// WEBPACK FOOTER //
// ./components/certificate-template/certificate-template-constants.js